import { createTheme } from "@mui/material";
import { theme } from "./custom-theme";

let themeMUI = createTheme({ ...theme });

export default themeMUI;
